import { Mail, Phone, Linkedin } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";
import { Reveal, Overline } from "./Reveal";
import { CONTACT } from "../data/content";

const Contact = () => {
  const { t } = useLanguage();

  return (
    <section id="contatti" data-testid="contact-section" className="relative py-28 sm:py-40 bg-travertine-light overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom_left,rgba(197,160,89,0.10),transparent_55%)]" />
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 relative">
        <Reveal>
          <Overline>{t.contact.overline}</Overline>
          <h2 className="font-serif text-5xl sm:text-6xl lg:text-8xl tracking-tight text-ink mt-6 leading-[1.02]">
            {t.contact.titleA}
            <br />
            <span className="italic text-gold">{t.contact.titleB}</span>
          </h2>
          <p className="mt-8 max-w-xl text-base lg:text-lg leading-relaxed text-ink/60">{t.contact.intro}</p>
        </Reveal>

        <Reveal delay={0.15} className="mt-16 grid sm:grid-cols-2 lg:grid-cols-3 gap-10">
          <div>
            <p className="text-[10px] font-mono uppercase tracking-[0.25em] text-ink/45 flex items-center gap-2">
              <Mail size={13} className="text-gold" /> {t.contact.emailLabel}
            </p>
            <a
              data-testid="contact-email-link"
              href={`mailto:${CONTACT.email}`}
              className="mt-3 inline-block font-serif text-xl sm:text-2xl text-ink border-b border-gold/60 pb-1 hover:text-gold transition-colors duration-300 break-all"
            >
              {CONTACT.email}
            </a>
          </div>
          <div>
            <p className="text-[10px] font-mono uppercase tracking-[0.25em] text-ink/45 flex items-center gap-2">
              <Phone size={13} className="text-gold" /> {t.contact.phoneLabel}
            </p>
            <a
              data-testid="contact-phone-link"
              href={`tel:${CONTACT.phone.replace(/\s/g, "")}`}
              className="mt-3 inline-block font-serif text-xl sm:text-2xl text-ink border-b border-gold/60 pb-1 hover:text-gold transition-colors duration-300"
            >
              {CONTACT.phoneDisplay}
            </a>
          </div>
          <div>
            <p className="text-[10px] font-mono uppercase tracking-[0.25em] text-ink/45 flex items-center gap-2">
              <Linkedin size={13} className="text-gold" /> LinkedIn
            </p>
            <a
              data-testid="contact-linkedin-link"
              href={CONTACT.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-3 inline-block font-serif text-xl sm:text-2xl text-ink border-b border-gold/60 pb-1 hover:text-gold transition-colors duration-300"
            >
              {t.contact.linkedinLabel}
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default Contact;
